import { CardElement} from '@stripe/react-stripe-js';

const createOptions = (fontSize="16px", padding) => {
    return {
      style: {
        base: {
          fontSize,
          color: '#424770',
          letterSpacing: '0.025em',
          '::placeholder': {
            color: '#aab7c4',
          },
          ...(padding ? { padding } : {}),
        },
        invalid: {
          color: '#9e2146',
        },
      },
    };
  };

const CardInput = ()=>{

    return(
        <CardElement 
            options={createOptions()}
        />
    )
}

export default CardInput;
